// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"27ab0392","308":"0dd1a100","444":"6b432517","533":"592540b4","581":"188e6155","645":"6d84d220","652":"51687cec","847":"00cd6e22"}[chunkId] + ".chunk.js";
};